import { IDocument } from 'common/document/interfaces/document';

const canApprove = {
  status: true,
  helpText: '',
};

interface ICanApproveDotMedical {
  document?: IDocument;
  isEnabled?: boolean;
  isFormValid?: boolean;
}

export const canApproveDotMedical = ({
  document,
  isEnabled,
  isFormValid,
}: ICanApproveDotMedical) => {
  if (!isFormValid) {
    return {
      status: false,
      helpText: '<div>Fill out the form.</div>',
    };
  }

  if (!isEnabled) {
    return canApprove;
  }

  if (
    document?.details &&
    Array.isArray(document.details) &&
    document?.documentFiles &&
    Array.isArray(document.documentFiles)
  ) {
    const examinerLicenseNumber = document.details.find(
      (detail) => detail.fieldName === 'examinerLicenseNumber'
    );
    const verificationImage = document.documentFiles.find(
      (file) => file.documentName === 'verification'
    );

    if (examinerLicenseNumber?.fieldValue && verificationImage) {
      return canApprove;
    }
  }

  return {
    status: false,
    helpText:
      '<div><b>Not Verified:</b></div><div>Upload FMCSA verification to approve document.</div>',
  };
};
